import React from "react"
import PropTypes from "prop-types"
import { format } from "date-fns-tz"
import { parseISO } from "date-fns"
import slugify from "lib/slugify"
import InvisibleButton from "components/InvisibleButton"
import theme from "theme"

const DateNavButtons = ({ dates }) => (
  <div
    css={{
      display: "grid",
      gridTemplateColumns: `repeat(${dates.length}, 1fr)`,
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: `2px solid ${theme.black}`,
      background: "var(--dateNavBackground)",
      [`@media (max-width: ${185 * dates.length}px)`]: {
        display: "none",
      },
    }}
  >
    {dates.map(date => (
      <InvisibleButton
        onClick={() => {
          const target = document.querySelector(
            "#" + slugify(format(parseISO(date), "EEEE, LLLL do"))
          )
          if (target) {
            window.scrollTo({ top: target.offsetTop, behavior: "smooth" })
          }
        }}
        key={date}
        css={{
          ...theme.h2,
          padding: "32px 24px",
          textAlign: "center",
          borderRight: `2px solid ${theme.black}`,
          ":last-child": {
            borderRight: 0,
          },
          ":hover": {
            textDecoration: "underline",
          },
        }}
      >
        {format(parseISO(date), "LLLL do")}
      </InvisibleButton>
    ))}
  </div>
)

export default DateNavButtons

DateNavButtons.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}
